import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'

import { Loading } from '@/components/Loading'
import { LoadingFailedAlert } from '@/components/LoadingFailedAlert'
import { Step4Wrapper } from '@/containers/steps/property/Step4/Step4Wrapper'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { MeetingRecordProvider } from '@/context/MeetingRecordProvider'
import { SelectedOffersAddonProvider } from '@/context/SelectedOffersAddonProvider'
import { SelectedQuoteProvider } from '@/context/SelectedQuoteContext'
import { SidebarProvider } from '@/context/SidebarContext'
import { StepsProvider } from '@/context/StepsContext'
import { WizzardHeaderProvider } from '@/context/WizzardHeaderContext'
import { WithAuth } from '@/hoc/WithAuth'
import { useApp } from '@/hooks/useApp'

const Step4PageComponent = () => {
  const { product, setProduct } = useApp()
  const navigate = useNavigate()
  const {
    insuranceParamsId: paramsId,
    isLoadingData,
    insuranceParams,
    isContracted,
    error
  } = useInsuranceParams()

  const [showData, setShowData] = useState(false)
  useEffect(() => {
    setShowData(!isLoadingData && !!insuranceParams && product == insuranceParams.generalParams.insuranceCategoryType)
  }, [!!insuranceParams, isLoadingData, product])

  useEffect(() => {
    if (isContracted) navigate(`/property/steps/complete/${paramsId}`)
  }, [isContracted])

  useEffect(() => {
    if (insuranceParams?.generalParams?.insuranceCategoryType)
      setProduct(insuranceParams?.generalParams?.insuranceCategoryType)
  }, [insuranceParams?.generalParams?.insuranceCategoryType])

  return (
    <StepsProvider currentStepId={4}>
      <SidebarProvider>
        <WizzardHeaderProvider>
          {isLoadingData && <Loading large={true} />}
          {!isLoadingData && error && <LoadingFailedAlert />}
          {showData && (
            <MeetingRecordProvider insuranceParamsId={paramsId!}>
              <SelectedQuoteProvider>
                <SelectedOffersAddonProvider>
                  <Step4Wrapper />
                </SelectedOffersAddonProvider>
              </SelectedQuoteProvider>
            </MeetingRecordProvider>
          )}
        </WizzardHeaderProvider>
      </SidebarProvider>
    </StepsProvider>
  )
}

export const Step4Page = WithAuth(Step4PageComponent)
